import React from 'react';
import RenderedComponentsSingleton from 'src/common/singleton/RenderedComponentsSingleton';
import RenderedIconIndicator from 'src/components/rendered/RenderedIconIndicator';
import RenderedAdder from 'src/components/rendered/RenderedAdder';
import RenderedBarChart from 'src/components/rendered/RenderedBarChart';
import RenderedPieChart from 'src/components/rendered/RenderedPieChart';
import RenderedLineChart from 'src/components/rendered/RenderedLineChart';

export default function Subscriptions() {

	React.useLayoutEffect(() => {
		const singleton = new RenderedComponentsSingleton();
		
		singleton.subscribeComponent(
			{
				name: 'iconIndicator',
				props: [ 'title', 'description', 'value', 'icon', ],
				component: RenderedIconIndicator,
			}
		);
		singleton.subscribeComponent(
			{
				name: 'adder',
				props: [ 'rows', 'field', 'description', 'icon', ],
				component: RenderedAdder,
			}
		);
		singleton.subscribeComponent(
			{
				name: 'barChart',
				props: [ 'rows', 'xAxisKey', 'yAxisKey', 'title', ],
				component: RenderedBarChart,
			}
		);
		singleton.subscribeComponent(
			{
				name: 'pieChart',
				props: [ 'rows', 'label', 'value', 'title', ],
				component: RenderedPieChart,
			}
		);
		singleton.subscribeComponent(
			{
				name: 'lineChart',
				props: [ 'rows', 'title', 'date', 'kind', 'value', ],
				component: RenderedLineChart,
			}
		);
	}, []);

	return (
		<>
        
		</>
	);
}
